import { Sidebar } from "primereact/sidebar";
import { useAppContext } from "../../../../AppContext";
import { Navigation } from "../header/Navigation";
import { SelectField } from "../../forms/inputs/dropdown/SelectField";
import { RenderWhen } from "../../../infrastructure/components/RenderWhen";
import { UserRole } from "../../../enums";
import { getCurrentUserRole } from "../../../infrastructure/helpers/userHelper";
import { useNavigate } from "react-router-dom";
import {
  getDefaultRoutePath,
  routePaths,
} from "../../../infrastructure/routes/routePaths";
import styles from "../Layout.module.scss";
import classNames from "classnames";
import {
  AppDropdownMenu,
  IDropdownMenuItem,
} from "../../AppDropdownMenu/AppDropdownMenu";
import { endpointsMetadata } from "../../../infrastructure/routes/endpointsMetadata";
import { useReferralProgram } from "../../../../components/referralProgram/hooks/useReferralProgram";
import { ReferralNavigationItem } from "../../../../components/referralProgram/components/ReferralNavigationItem/ReferralNavigationItem";
import { ReferralProgramDialog } from "../../../../components/referralProgram/ReferralProgramDialog";
export const SharedSidebar = () => {
  const {
    showSidebar,
    setShowSidebar,
    selectedStudio,
    currentUser,
    userStudios,
    requestStudioSwitch,
  } = useAppContext();

  const navigate = useNavigate();
  const referralProgram = useReferralProgram();

  const normalizePath = (path?: string) =>
    path?.toLowerCase()?.replace(/\/+$/, "");

  const invoiceEndpoint = normalizePath(endpointsMetadata.invoice.getForTenant);
  const permissions = currentUser?.permissions?.map(normalizePath);
  const hasInvoicePermission = permissions?.some(
    (p) => invoiceEndpoint && p && invoiceEndpoint.includes(p),
  );

  const userMenuItems: IDropdownMenuItem[] = [
    {
      label: "Моят профил",
      onClick: () => {
        navigate(routePaths.portalMyProfile);
        setShowSidebar(false);
      },
    },
    ...(hasInvoicePermission
      ? [
          {
            label: "Фактури",
            onClick: () => {
              navigate(routePaths.invoices);
              setShowSidebar(false);
            },
          },
        ]
      : []),
    {
      label: "Моите съгласия",
      onClick: () => {
        navigate(routePaths.portalMyConsents);
        setShowSidebar(false);
      },
    },
    { separator: true, label: "" },
    {
      label: "Отписване",
      onClick: () => {
        navigate(routePaths.logout);
        setShowSidebar(false);
      },
    },
  ];

  const customSidebarHeader = (
    <div className={styles.root_sidebar_header}>
      <div className={styles.root_sidebar_header_studio}>
        {selectedStudio?.name}
      </div>
      <RenderWhen condition={!!currentUser?.firstName}>
        <div className={styles.root_sidebar_header_user}>
          Добре дошли, {currentUser?.firstName} {currentUser?.lastName}
        </div>
      </RenderWhen>
      <RenderWhen condition={!currentUser?.firstName}>
        <div className={styles.root_sidebar_header_user}>Добре дошли</div>
      </RenderWhen>
    </div>
  );

  return (
    <>
      <Sidebar
        header={customSidebarHeader}
        visible={showSidebar}
        className={classNames(styles.root_sidebar_menu, {
          [styles.root_sidebar_training_mode]: selectedStudio?.isTraining,
        })}
        onHide={() => setShowSidebar(false)}
      >
        <div className={styles.root_sidebar_wrapper}>
          <div className={styles.root_sidebar_nav_section}>
            <Navigation hideSidebar={() => setShowSidebar(false)} />
            <RenderWhen condition={referralProgram.isAvailable}>
              <ReferralNavigationItem onClick={referralProgram.openDialog} />
            </RenderWhen>
          </div>
          <div className={styles.root_sidebar_bottom_section}>
            <RenderWhen condition={!!currentUser?.firstName}>
              <div className={styles.root_sidebar_user_section}>
                <span className={styles.root_sidebar_user_section_name}>
                  {currentUser?.firstName} {currentUser?.lastName}
                </span>
                <AppDropdownMenu
                  items={userMenuItems}
                  triggerIconSize="18px"
                  triggerIconColor="rgba(255,255,255,0.8)"
                />
              </div>
            </RenderWhen>
            <RenderWhen condition={userStudios?.length > 1}>
              <SelectField
                width="100%"
                label="Избран обект"
                options={userStudios}
                value={selectedStudio?.id}
                onChange={(newValue) => {
                  requestStudioSwitch(newValue ?? userStudios[0].id, () =>
                    navigate(getDefaultRoutePath(currentUser)),
                  );
                }}
                includeId={
                  !!currentUser?.role &&
                  getCurrentUserRole(currentUser) === UserRole.GlobalAdmin
                }
                required
              />
            </RenderWhen>
          </div>
        </div>
      </Sidebar>

      {/* Outside the sidebar, which unmounts its content once it closes */}
      <RenderWhen condition={referralProgram.isAvailable}>
        <ReferralProgramDialog
          visible={referralProgram.isDialogVisible}
          onHide={referralProgram.closeDialog}
        />
      </RenderWhen>
    </>
  );
};
